import React from 'react';

const ButtonNextInformativo = ({ callClick, buttonName, callFunction, css, etiqueta, icons }) => {
  return (
    <button
      name={buttonName}
      className={css ? `${css} ButtonBase` : 'ButtonBase'}
      type="button"
      onSubmit={callFunction}
      onClick={callClick}
    >
      {' '}
      {etiqueta}
      {icons && <img src={icons} className="iconButtonBase rotateArrow" alt="svg" width="15px" height="15px" />}
      {' '}
    </button>
  );
};

export default ButtonNextInformativo;
